import React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';

export default class GradebookOptions extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    exportingNotes: PropTypes.bool
  };

  render() {
    return (
      <a className="grades-option" onClick={this.props.onClick}>
        <div className="item link">
          <span className="icon">
            <i className="custom-icons-download-tray grades-option-icon"></i>
          </span>
          <span className="text">
            {I18n.t(this.props.exportingNotes ? 'classroomSettings.exportingGrades' : 'classroomSettings.exportGrade')}
          </span>
        </div>
      </a>
    );
  }
}
